<script lang="ts">
	import FieldError from "$form/Fields/Shared/FieldError.svelte";
	import Label from "$form/Fields/Shared/Label.svelte";
	import Description from "$form/Fields/Shared/Description.svelte";
	import Rating from "./Rating.svelte";
	import { createEventDispatcher } from "svelte";
	export let field: FieldDisplay & { type: "Rating" };
	export let value: string;

	const dispatch = createEventDispatcher();
</script>

<div class="field-label-cover">
	{#if field.labelHTMLComputed && field.settings.hideLabel !== true}
		<Label html="{field.labelHTMLComputed}" />
		{#if field.descriptionHTMLComputed}
			<Description html="{field.descriptionHTMLComputed}" />
		{/if}
	{/if}
</div>
<div class="field-input-cover">
	<Rating
		field="{field}"
		bind:value="{value}"
		on:clickOutside="{() => {
			dispatch('updateOther', {
				active: false
			});
		}}"
		on:click="{() => {
			dispatch('updateOther', {
				active: true
			});
		}}" />
	<FieldError
		visible="{field.tainted}"
		valid="{field.valid}"
		errorNumber="{field.errorNumber}"
		errorType="{field.errorType}" />
</div>
